'use client';

import { useSyncExternalStore } from 'react';

function subscribe(onChange: () => void): () => void {
  document.addEventListener('visibilitychange', onChange);
  return () => document.removeEventListener('visibilitychange', onChange);
}

/**
 * True while the tab is visible. Drives conditional `refetchInterval` so
 * polling surfaces (DM threads, FRONT-308) stop while the tab is hidden.
 * SSR snapshot is `true` — the first client render corrects it if hidden.
 */
export function useDocumentVisible(): boolean {
  return useSyncExternalStore(
    subscribe,
    () => document.visibilityState === 'visible',
    () => true
  );
}
